module.exports = __webpack_public_path__ + "static/media/villaomr.69941553.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Placeholders/villaomr.png
// module id = 97
// module chunks = 0